import { ApiError } from "../types/apiResponse";

export const getApiErrorForDisplay = (errors: ApiError[]) =>
  errors.map((error: ApiError) => error.details).join(".\n");
